import {
  Cliente,
  ClienteFormValue,
  CuentaInclub,
  Membresia,
  PaginaClientes,
  ResultadoImportacion,
  TipoCliente,
  esPersonaNatural,
} from '../models/clientes.model';
import {
  CustomerDto,
  CustomerRequestDto,
  CustomerTypeDto,
  ImportResultDto,
  MemberLookupDto,
  MemberRequestDto,
  MembershipDto,
  PageDto,
} from './clientes-api.types';

export function tipoApi(tipo: TipoCliente): CustomerTypeDto {
  return tipo === 'empresa' ? 'COMPANY' : 'PERSON';
}

export function filtroSocios(tipo: TipoCliente): boolean | null {
  if (tipo === 'empresa') {
    return null;
  }
  return tipo === 'socio';
}

export function clienteDesdeApi(dto: CustomerDto): Cliente {
  const empresa = dto.customer_type === 'COMPANY';
  let tipo: TipoCliente = 'persona';
  if (empresa) {
    tipo = 'empresa';
  } else if (dto.membership) {
    tipo = 'socio';
  }
  return {
    id: dto.id,
    tipo,
    tipoDocumento: dto.document_type,
    numeroDocumento: dto.document_number,
    nombres: (empresa ? dto.business_name : dto.first_name) ?? '',
    apellidos: empresa ? '' : (dto.last_name ?? ''),
    fechaNacimiento: dto.birth_date,
    telefono: dto.phone ?? '',
    correo: dto.email ?? '',
    direccion: dto.address ?? '',
    codigo: dto.code ?? '',
    distrito: dto.district ?? '',
    activo: dto.is_active,
    membresia: dto.membership ? membresiaDesdeApi(dto.membership) : null,
  };
}

function membresiaDesdeApi(dto: MembershipDto): Membresia {
  return {
    cuentaId: dto.external_account_id,
    usuario: dto.external_username ?? '',
    estadoId: dto.state_id ?? '',
    estado: dto.state_name ?? 'Sin estado',
    activa: dto.active,
    socioDesde: dto.member_since,
    sincronizado: dto.synced_at,
  };
}

export function clienteHaciaApi(form: ClienteFormValue, incluirTipo: boolean): CustomerRequestDto {
  const persona = esPersonaNatural(form.tipo);
  return {
    ...(incluirTipo ? { customer_type: tipoApi(form.tipo) } : {}),
    document_type: form.tipoDocumento,
    document_number: form.numeroDocumento,
    first_name: persona ? form.nombres : null,
    last_name: persona ? form.apellidos : null,
    business_name: persona ? null : form.nombres,
    birth_date: persona ? form.fechaNacimiento : null,
    phone: form.telefono || null,
    email: form.correo || null,
    address: form.direccion || null,
    code: form.codigo || null,
    district: form.distrito || null,
    is_active: form.activo,
  };
}

export function socioHaciaApi(form: ClienteFormValue): MemberRequestDto {
  return {
    document_number: form.numeroDocumento,
    birth_date: form.fechaNacimiento,
    phone: form.telefono || null,
    email: form.correo || null,
    address: form.direccion || null,
    code: form.codigo || null,
    district: form.distrito || null,
    is_active: form.activo,
  };
}

export function cuentaInclubDesdeApi(dto: MemberLookupDto): CuentaInclub {
  return {
    numeroDocumento: dto.document_number,
    nombres: dto.first_name ?? '',
    apellidos: dto.last_name ?? '',
    telefono: dto.phone ?? '',
    usuario: dto.external_username ?? '',
    estado: dto.state_name ?? 'Sin estado',
    activa: dto.active,
    socioDesde: dto.member_since,
    clienteRegistrado: dto.customer ? clienteDesdeApi(dto.customer) : null,
    yaEsSocio: dto.already_member,
  };
}

export function paginaDesdeApi(dto: PageDto<CustomerDto>): PaginaClientes {
  return {
    items: dto.items.map(clienteDesdeApi),
    pagina: dto.page,
    tamano: dto.size,
    total: dto.total_elements,
    totalPaginas: dto.total_pages,
  };
}

export function importacionDesdeApi(dto: ImportResultDto): ResultadoImportacion {
  return {
    creados: dto.created,
    actualizados: dto.updated,
    errores: dto.errors.map((error) => ({ fila: error.row, mensaje: error.message })),
  };
}
